import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import type { PublicRouteProps } from './PublicRoute.types'

export default ({ authenticated = false, redirectUrl = '/', ...rest }: PublicRouteProps) => {
  const isBrowser = typeof window !== 'undefined'
  const browserUnauthenticated = isBrowser && !authenticated
  const browserAuthenticated = isBrowser && authenticated

  if (browserAuthenticated) {
    return <Redirect to={redirectUrl} />
  }

  if (browserUnauthenticated) {
    return <Route {...rest} />
  }

  return null
}
